import * as NextSkyTheme from "@NextSkyTheme/global";
import { eventModal } from "@NextSkyTheme/modal";

class PopupPassword extends HTMLElement {
  constructor() {
    super();
    this._boundOnClick = this._openModal.bind(this);
    this._boundOnKeyDown = this._onKeyDown.bind(this);
  }

  connectedCallback() {
    this.addEventListener("click", this._boundOnClick, false);
    this.addEventListener("keydown", this._boundOnKeyDown, false);

    if (window.__passwordFormHasErrors) {
      requestAnimationFrame(() => this._openModal());
    }

    requestAnimationFrame(() => this._interceptDeadLinks());
  }

  disconnectedCallback() {
    this.removeEventListener("click", this._boundOnClick, false);
    this.removeEventListener("keydown", this._boundOnKeyDown, false);
  }

  _interceptDeadLinks() {
    const page = this.closest(".main-password");
    if (!page) return;

    page.querySelectorAll('a[href="#"]').forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        this._openModal();
      });
    });
  }

  _onKeyDown(e) {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      this._openModal();
    }
  }

  _openModal() {
    if (!document.querySelector("password-modal-popup")) {
      const tpl = this.querySelector("template");
      if (tpl) {
        const wrapper = document.createElement("div");
        wrapper.appendChild(tpl.content.firstElementChild.cloneNode(true));
        NextSkyTheme.getBody().appendChild(
          wrapper.querySelector("password-modal-popup")
        );
      }
    }

    setTimeout(() => {
      const modal = document.querySelector("password-modal-popup");
      if (modal) {
        eventModal(modal, "open", true);
      }
    }, 100);

    NextSkyTheme.global.rootToFocus = this;
  }
}

customElements.define("popup-password", PopupPassword);
